import { render, staticRenderFns } from "./ProductShopLook.vue?vue&type=template&id=359eb1e4&scoped=true&"
import script from "./ProductShopLook.vue?vue&type=script&lang=js&"
export * from "./ProductShopLook.vue?vue&type=script&lang=js&"
import style0 from "./ProductShopLook.vue?vue&type=style&index=0&id=359eb1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359eb1e4",
  null
  
)

export default component.exports